export enum ConfirmationDialogActivatorActionTypes {
  UPDATE = "CONFIRMATION_DIALOG_ACTIVATOR/UPDATE",
  RESET = "CONFIRMATION_DIALOG_ACTIVATOR/RESET",
}
